import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import client from './apollo-client';
import { ApolloProvider } from 'react-apollo';
import App from './containers/app';

import 'sanitize.css/sanitize.css';
import './index.css';


const target = document.querySelector('#root');

render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
    </Provider>
  </ApolloProvider>,
  target
);



// WEBPACK FOOTER //
// ./src/index.js